import { connect } from "react-redux";
import { Nav, Tab } from "react-bootstrap";
import { useEffect, useState, useContext } from "react";

import { Show } from "../../hooks/Show";
import ReschedulingByIds from "./ReschedulingByIds";
import ReschedulingSuite from "./ReschedulingSuite";
import Topbar from '../../components/Navigation/Topbar';
import Sidebar from '../../components/Navigation/Sidebar';
import UploadMasivReschedule from "./UploadMasivReschedule";
import ReschedulingTableComponent from "./ReschedulingTableComponent";
import HistoryToReschedule from "./HistoryToReschedule";
import ReschedulingConfig from "./ReschedulingConfig";
import { noveltyManagementList } from "../../utils/enumsUtil";
import { PermissionContext } from "../../hooks/PermissionContext";


const Rescheduling = ({
  novelties,
  reduxGetCountByNovelty,
  reduxResetCountByNovelty,
  reduxGetNovelties,
  reduxResetAddressRescheduling,
}) => {
  const { hasPermission } = useContext(PermissionContext);

  const [title, setTitle] = useState();
  const [subTitle, setSubTitle] = useState();
  const [iconUploadMasiv, setIconUploadMasiv] = useState();
  const [defaultActiveTab, setDefaultActiveTab] = useState(
    hasPermission('feature:isClient') ? 'managedByCustomer' : 'managedByKiki'
  );
  const [activeTab, setActiveTab] = useState(
    hasPermission('feature:isClient') ? 'managedByCustomer' : 'managedByKiki'
  );

  useEffect(() => {
    reduxGetNovelties({
      page: 1,
      search: "",
      offset: 1000,
      status: 11,
    });

    setTitle("Reprogramación");
    setSubTitle("Módulo de Reprogramaciones");

    return () => {
      reduxResetCountByNovelty();
    };
  }, [])

  useEffect(() => {
    if (novelties && Object.keys(novelties).length > 0 && (defaultActiveTab != 'masiv' && defaultActiveTab != 'historyToReschedule')) {
      // reduxGetCountByNovelty({ listNovelties: ListReschedulingsByTypeNovelty(defaultActiveTab) });
    }
  }, [defaultActiveTab, novelties])

  const handleSelect = (tabSelected) => {
    if (tabSelected !== defaultActiveTab) {
      reduxResetAddressRescheduling();
      reduxResetCountByNovelty();
      setDefaultActiveTab(tabSelected);
      setActiveTab(tabSelected);
    }

    if (tabSelected !== 'masiv') {
      setTitle("Reprogramación");
      setSubTitle("Módulo de Reprogramaciones");
      setIconUploadMasiv(false)
    } else if (tabSelected === 'masiv') {
      setTitle("Reprogramaciones masivas");
      setSubTitle("Módulo de Reprogramaciones masivas");
      setIconUploadMasiv(true)
    }
  }

  const ListReschedulingsByTypeNovelty = (currentTab) => {
    const noveltyList = novelties && Object.keys(novelties).length > 0 &&
      novelties
        .filter((f) => f.isActive === true && (currentTab === "single" || noveltyManagementList[currentTab].some(n => n.code === f.code)))
        .map((ele, _key) => ({
          value: ele.code,
          label: ele.description,
          id: ele.idNovelty,
        }))

    const idNoveltyList = noveltyList.map(n => n.id);

    return idNoveltyList.join(",");
  }

  return (
    <div>
      <div id='wrapper'>
        <Sidebar />
        <div
          id='content-wrapper'
          className='d-flex flex-column'>
          <div id='content'>
            <Topbar />
            <div className='container-fluid'>
              <div className='d-sm-flex align-items-center mb-1'>
                <h1 className='h3 mb-0 text-gray-800 mr-3'>{title}</h1>
                {(iconUploadMasiv && <UploadMasivReschedule />)}
              </div>
              <p className='mb-4'>{subTitle}</p>
              <Tab.Container defaultActiveKey={defaultActiveTab} mountOnEnter={true} onSelect={(k) => handleSelect(k)}>
                <Nav variant="tabs" className=" d-flex flex-nowrap flex-row mt-2" >
                  <Show when='feature:tab-rescheduling-managed-by-kiki'>
                    <Nav.Item className='d-flex flex-column'>
                      <Nav.Link eventKey="managedByKiki">
                        Gestionadas por Kiki
                      </Nav.Link>
                    </Nav.Item>
                  </Show>
                  {
                    hasPermission('feature:isClient') || hasPermission('feature:tab-rescheduling-managed-by-customer') ?
                      (
                        <Nav.Item className='d-flex flex-column'>
                          <Nav.Link eventKey="managedByCustomer">
                            {hasPermission('feature:isClient') ? 'Individuales' : 'Gestionadas por el cliente'}
                          </Nav.Link>
                        </Nav.Item>
                      )
                      :
                      <></>
                  }
                  <Show when='feature:tab-rescheduling-automatic'>
                    <Nav.Item className='d-flex flex-column'>
                      <Nav.Link eventKey="automaticManagement">
                        Operativas
                      </Nav.Link>
                    </Nav.Item>
                  </Show>
                  <Show when='feature:tab-rescheduling-incidents'>
                    <Nav.Item className='d-flex flex-column'>
                      <Nav.Link eventKey="incidents">
                        Incidencias
                      </Nav.Link>
                    </Nav.Item>
                  </Show>
                  <Show when='feature:tab-shipments-history-to-reschedule'>
                    <Nav.Item className='d-flex flex-column'>
                      <Nav.Link eventKey="historyToReschedule">
                        Histórico
                      </Nav.Link>
                    </Nav.Item>
                  </Show>
                  <Show when='feature:tab-rescheduling-suite'>
                    <Nav.Item className='d-flex flex-column'>
                      <Nav.Link eventKey="suite">
                        Suite
                      </Nav.Link>
                    </Nav.Item>
                  </Show>
                  <Show when='feature:tab-rescheduling-masiv'>
                    <Nav.Item className='d-flex flex-column'>
                      <Nav.Link eventKey="masiv">
                        Masivas
                      </Nav.Link>
                    </Nav.Item>
                  </Show>
                  <Show when='feature:tab-rescheduling-config'>
                    <Nav.Item className='d-flex flex-column'>
                      <Nav.Link eventKey="config">
                        Configuración
                      </Nav.Link>
                    </Nav.Item>
                  </Show>
                </Nav>
                <Tab.Content>
                  <Show when='feature:tab-rescheduling-managed-by-kiki'>
                    <Tab.Pane eventKey="managedByKiki">
                      <ReschedulingTableComponent currentTab={activeTab} />
                    </Tab.Pane>
                  </Show>
                  {hasPermission('feature:isClient') || hasPermission('feature:tab-rescheduling-managed-by-customer') ?
                    (
                      <Tab.Pane eventKey="managedByCustomer">
                        <ReschedulingTableComponent currentTab={activeTab} />
                      </Tab.Pane>
                    )
                    : null
                  }
                  <Show when='feature:tab-rescheduling-automatic'>
                    <Tab.Pane eventKey="automaticManagement">
                      <ReschedulingTableComponent currentTab={activeTab} />
                    </Tab.Pane>
                  </Show>
                  <Show when='feature:tab-rescheduling-incidents'>
                    <Tab.Pane eventKey="incidents">
                      <ReschedulingTableComponent currentTab={activeTab} />
                    </Tab.Pane>
                  </Show>
                  <Tab.Pane eventKey="single">
                    <ReschedulingTableComponent currentTab="single" />
                  </Tab.Pane>
                  <Show when='feature:tab-shipments-history-to-reschedule'>
                    <Tab.Pane eventKey="historyToReschedule">
                      <HistoryToReschedule currentTab={activeTab} />
                    </Tab.Pane>
                  </Show>
                  <Show when='feature:tab-rescheduling-suite'>
                    <Tab.Pane eventKey="suite">
                      <ReschedulingSuite />
                    </Tab.Pane>
                  </Show>
                  <Show when='feature:tab-rescheduling-masiv'>
                    <Tab.Pane eventKey="masiv">
                      <ReschedulingByIds />
                    </Tab.Pane>
                  </Show>
                  <Show when='feature:tab-rescheduling-config'>
                    <Tab.Pane eventKey="config">
                      <ReschedulingConfig />
                    </Tab.Pane>
                  </Show>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};
const mapStateToProps = (state) => {
  return {
    novelties: state.noveltyState.novelties,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reduxGetCountByNovelty: (payload) =>
      dispatch({
        type: 'FETCH_COUNT_BY_NOVELTY_RESCHEDULING',
        value: payload,
      }),
    reduxResetCountByNovelty: () =>
      dispatch({
        type: 'RESET_TOTAL_BY_NOVELTY_RESCHEDULING',
      }),
    reduxGetNovelties: (payload) =>
      dispatch({
        type: 'FETCH_NOVELTIES_FOR_RESCHEDULE_REQUEST',
        value: payload,
      }),
    reduxResetAddressRescheduling: () =>
      dispatch({
        type: 'RESET_ADDRESSES_RESCHEDULING',
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Rescheduling);